"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";

import {
  performanceTestingHeroData,
  performanceStatsData,
  performanceSolutionsAndProcessData,
  performancePortfolioData,
  performanceTechnologiesData,
  performanceAboutData,
  performanceTestingFaqs,
} from "src/utils/mock/performanceTestingData";

import { caseStudies } from "src/utils/mock/caseStudies";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function PerformanceTestingComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    return project.projectStatus?.toLowerCase() === "active";
  });

  const filteredData = {
    ...performancePortfolioData,
    projects: {
      liveProjects: activeProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={performanceTestingHeroData} />
      <TechStats stats={performanceStatsData} />
      <WhyChooseUs data={performanceSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={performanceTechnologiesData} techIcons={techIcons} />
          <TechsSection sections={performanceAboutData} mainTitle="About Performance Testing" />
        </div>
      </section>

      <FAQSection faqs={performanceTestingFaqs} />
      <CommonContactSection />
    </div>
  );
}
